module.exports = __webpack_public_path__ + "assets/images/longevidade.36b1c949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kits/longevidade.png
// module id = 820
// module chunks = 1